/**
 * @generated SignedSource<<c02bda20b35953597d26ba3053d3b396>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivityVisibility = "AUTHENTICATED" | "MEMBERS" | "UNAUTHENTICATED";
export type LocationKind = "HYBRID" | "IN_PERSON" | "ONLINE";
export type RewardKind = "BADGE" | "LEARNING" | "MONEY" | "SWAG";
import { DateTime } from "@/common/relayCustomScalar";
import { TimeZone } from "@/common/relayCustomScalar";
export type UpdateEventInput = {
  about?: string | null | undefined;
  audience?: UpdateAudienceGroupsInput | null | undefined;
  banner?: any | null | undefined;
  description?: string | null | undefined;
  gettingStarted?: string | null | undefined;
  inviteEmail?: string | null | undefined;
  purpose?: string | null | undefined;
  rewards?: ReadonlyArray<RewardInput> | null | undefined;
  rules?: string | null | undefined;
  shortDescription?: string | null | undefined;
  slug?: string | null | undefined;
  tags?: ReadonlyArray<string> | null | undefined;
  thumbnail?: any | null | undefined;
  timeline?: UpdateTimelineInput | null | undefined;
  title?: string | null | undefined;
  useLegacyDescription?: boolean | null | undefined;
  visibility?: ActivityVisibility | null | undefined;
};
export type RewardInput = {
  amount?: AmountRangeInput | null | undefined;
  description: string;
  kind: RewardKind;
};
export type AmountRangeInput = {
  end: number;
  start: number;
};
export type UpdateTimelineInput = {
  endDate?: any | null | undefined;
  location?: LocationInput | null | undefined;
  startDate?: any | null | undefined;
  steps?: ReadonlyArray<TimelineStepInput> | null | undefined;
  timezone?: TimeZone | null | undefined;
};
export type TimelineStepInput = {
  date: any;
  label: string;
};
export type LocationInput = {
  city?: string | null | undefined;
  country?: string | null | undefined;
  kind: LocationKind;
};
export type UpdateAudienceGroupsInput = {
  groups: ReadonlyArray<AudienceGroupInput>;
};
export type AudienceGroupInput = {
  items: ReadonlyArray<string>;
  label: string;
  position: number;
};
export type EventRulesPageUpdateEventMutation$variables = {
  id: string;
  input: UpdateEventInput;
};
export type EventRulesPageUpdateEventMutation$data = {
  readonly updateEvent: {
    readonly node: {
      readonly id: string;
      readonly latestRule: {
        readonly entityAgreement: {
          readonly createdAt: DateTime;
          readonly id: string;
        } | null | undefined;
        readonly id: string;
        readonly text: string;
      };
    };
  };
};
export type EventRulesPageUpdateEventMutation = {
  response: EventRulesPageUpdateEventMutation$data;
  variables: EventRulesPageUpdateEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "updateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventRulesPageUpdateEventMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventRulesPageUpdateEventMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "a7e5ab41c0342f217e4ee570557a86a8",
    "id": null,
    "metadata": {},
    "name": "EventRulesPageUpdateEventMutation",
    "operationKind": "mutation",
    "text": "mutation EventRulesPageUpdateEventMutation(\n  $id: ID!\n  $input: UpdateEventInput!\n) {\n  updateEvent(id: $id, input: $input) {\n    node {\n      id\n      latestRule {\n        id\n        text\n        entityAgreement {\n          id\n          createdAt\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2e38575ab182917125b8bb71ffe56872";

export default node;
